/**
 * PostHog identification - links a Firebase Auth user to a PostHog person and
 * attaches the currently known traffic-source attribution to that profile.
 */
import posthog from "posthog-js";
import type { User } from "firebase/auth";
import { getCurrentUTMParameters } from "./utmService";
import { getCurrentFbclid } from "./fbclidService";

/**
 * Identify the current user in PostHog. Call this whenever auth state
 * resolves to a non-anonymous user (e.g. on every onAuthStateChanged), not
 * just at sign-in time - posthog.identify() is idempotent and merges into
 * the same person.
 */
export function identifyPostHogUser(user: User): void {
  if (!user || user.isAnonymous) {
    return;
  }

  const utmParams = getCurrentUTMParameters();
  const fbclid = getCurrentFbclid();

  posthog.identify(user.uid, {
    ...(user.email ? { email: user.email } : {}),
    ...(utmParams.utm_source ? { utm_source: utmParams.utm_source } : {}),
    ...(utmParams.utm_medium ? { utm_medium: utmParams.utm_medium } : {}),
    ...(utmParams.utm_campaign ? { utm_campaign: utmParams.utm_campaign } : {}),
    ...(utmParams.exocode ? { exocode: utmParams.exocode } : {}),
    ...(utmParams.referrer ? { referrer: utmParams.referrer } : {}),
    ...(fbclid ? { fbclid } : {}),
  });
}
